module.exports = __webpack_public_path__ + "img/upload.a145f585.png";